import { c as _c } from "react/compiler-runtime";
import { ProductTypeEnum } from '@systemeio/digital-store-shared';
import { getLanguageCodeByLocale } from '@systemeio/ui';
import ContentSkeleton from 'modules/stores/store/components/content-skeleton';
import StoreEditDesign from 'modules/stores/store/components/design/store-edit-design';
import StoreContent from 'modules/stores/store/components/store-content';
import StoreEdit from 'modules/stores/store/components/store-edit';
import StoreLocoWrapper from 'modules/stores/store/components/store-loco-wrapper';
import LinkEdit from 'modules/stores/store/content/link/link-edit';
import { LinkItemViewType } from 'modules/stores/store/content/link/types/link-interface';
import OptinEdit from 'modules/stores/store/content/optin/optin-edit';
import { OptinItemViewType } from 'modules/stores/store/content/optin/types/optin-interface';
import ProductEdit from 'modules/stores/store/content/product/digital-product/product-download/edit';
import Edit from 'modules/stores/store/content/product/digital-product/product-e-course/edit';
import PhysicalProductEdit from 'modules/stores/store/content/product/physical-product/edit';
import { PhysicalProductItemViewType, ProductDownloadItemViewType, ProductECourseItemViewType } from 'modules/stores/store/content/product/types/product-interface';
import ProfileEdit from 'modules/stores/store/content/profile/profile-edit';
import { StoreTabEnum } from 'modules/stores/store/enum/store-tab-enum';
import { useStore } from 'modules/stores/store/hooks/use-store';
import { useStoreQuery } from 'modules/stores/store/hooks/use-store-query';
import { useRouter } from 'next/router';
import { FC } from 'react';
const ContentWrapper: FC = () => {
  const $ = _c(53);
  const {
    tab,
    storeId,
    itemId,
    productType
  } = useStoreQuery();
  const {
    data: storeView
  } = useStore(storeId);
  const {
    isReady
  } = useRouter();
  let content;
  if (storeView && isReady) {
    let t0;
    if ($[0] !== itemId || $[1] !== storeView.items) {
      let t1;
      if ($[3] !== itemId) {
        t1 = item => item.itemId === itemId;
        $[3] = itemId;
        $[4] = t1;
      } else {
        t1 = $[4];
      }
      t0 = storeView.items.find(t1);
      $[0] = itemId;
      $[1] = storeView.items;
      $[2] = t0;
    } else {
      t0 = $[2];
    }
    const item_0 = t0;
    let t1;
    if ($[5] !== storeView.locale) {
      t1 = getLanguageCodeByLocale(storeView.locale);
      $[5] = storeView.locale;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    const languageCode = t1;
    bb0: switch (tab) {
      case StoreTabEnum.profile:
        {
          let t2;
          if ($[7] !== storeView) {
            t2 = <ProfileEdit store={storeView} />;
            $[7] = storeView;
            $[8] = t2;
          } else {
            t2 = $[8];
          }
          content = t2;
          break bb0;
        }
      case StoreTabEnum.link:
        {
          const t2 = item_0 as LinkItemViewType;
          let t3;
          if ($[9] !== languageCode || $[10] !== storeView.id || $[11] !== t2) {
            t3 = <LinkEdit storeId={storeView.id} link={t2} languageCode={languageCode} />;
            $[9] = languageCode;
            $[10] = storeView.id;
            $[11] = t2;
            $[12] = t3;
          } else {
            t3 = $[12];
          }
          let t4;
          if ($[13] !== languageCode || $[14] !== t3) {
            t4 = <StoreLocoWrapper languageCode={languageCode}>{t3}</StoreLocoWrapper>;
            $[13] = languageCode;
            $[14] = t3;
            $[15] = t4;
          } else {
            t4 = $[15];
          }
          content = t4;
          break bb0;
        }
      case StoreTabEnum.optin:
        {
          const t2 = item_0 as OptinItemViewType | undefined;
          let t3;
          if ($[16] !== languageCode || $[17] !== storeView.id || $[18] !== t2) {
            t3 = <OptinEdit storeId={storeView.id} optin={t2} languageCode={languageCode} />;
            $[16] = languageCode;
            $[17] = storeView.id;
            $[18] = t2;
            $[19] = t3;
          } else {
            t3 = $[19];
          }
          let t4;
          if ($[20] !== languageCode || $[21] !== t3) {
            t4 = <StoreLocoWrapper languageCode={languageCode}>{t3}</StoreLocoWrapper>;
            $[20] = languageCode;
            $[21] = t3;
            $[22] = t4;
          } else {
            t4 = $[22];
          }
          content = t4;
          break bb0;
        }
      case StoreTabEnum.product:
        {
          bb1: switch (productType) {
            case ProductTypeEnum.download:
              {
                const t2 = item_0 as ProductDownloadItemViewType | undefined;
                let t3;
                if ($[23] !== languageCode || $[24] !== storeView.id || $[25] !== t2) {
                  t3 = <ProductEdit storeId={storeView.id} item={t2} languageCode={languageCode} />;
                  $[23] = languageCode;
                  $[24] = storeView.id;
                  $[25] = t2;
                  $[26] = t3;
                } else {
                  t3 = $[26];
                }
                let t4;
                if ($[27] !== languageCode || $[28] !== t3) {
                  t4 = <StoreLocoWrapper languageCode={languageCode}>{t3}</StoreLocoWrapper>;
                  $[27] = languageCode;
                  $[28] = t3;
                  $[29] = t4;
                } else {
                  t4 = $[29];
                }
                content = t4;
                break bb1;
              }
            case ProductTypeEnum.eCourse:
              {
                const t2 = item_0 as ProductECourseItemViewType | undefined;
                let t3;
                if ($[30] !== languageCode || $[31] !== storeView.id || $[32] !== t2) {
                  t3 = <Edit storeId={storeView.id} item={t2} languageCode={languageCode} />;
                  $[30] = languageCode;
                  $[31] = storeView.id;
                  $[32] = t2;
                  $[33] = t3;
                } else {
                  t3 = $[33];
                }
                let t4;
                if ($[34] !== languageCode || $[35] !== t3) {
                  t4 = <StoreLocoWrapper languageCode={languageCode}>{t3}</StoreLocoWrapper>;
                  $[34] = languageCode;
                  $[35] = t3;
                  $[36] = t4;
                } else {
                  t4 = $[36];
                }
                content = t4;
                break bb1;
              }
            case ProductTypeEnum.physicalProduct:
              {
                const t2 = item_0 as PhysicalProductItemViewType | undefined;
                let t3;
                if ($[37] !== languageCode || $[38] !== storeView.id || $[39] !== t2) {
                  t3 = <PhysicalProductEdit storeId={storeView.id} item={t2} languageCode={languageCode} />;
                  $[37] = languageCode;
                  $[38] = storeView.id;
                  $[39] = t2;
                  $[40] = t3;
                } else {
                  t3 = $[40];
                }
                let t4;
                if ($[41] !== languageCode || $[42] !== t3) {
                  t4 = <StoreLocoWrapper languageCode={languageCode}>{t3}</StoreLocoWrapper>;
                  $[41] = languageCode;
                  $[42] = t3;
                  $[43] = t4;
                } else {
                  t4 = $[43];
                }
                content = t4;
              }
          }
          break bb0;
        }
      case StoreTabEnum.theme:
        {
          let t2;
          if ($[44] !== storeView) {
            t2 = <StoreEditDesign store={storeView} />;
            $[44] = storeView;
            $[45] = t2;
          } else {
            t2 = $[45];
          }
          content = t2;
          break bb0;
        }
      case StoreTabEnum.storeSettings:
        {
          let t2;
          if ($[46] !== storeView) {
            t2 = <StoreEdit store={storeView} />;
            $[46] = storeView;
            $[47] = t2;
          } else {
            t2 = $[47];
          }
          content = t2;
          break bb0;
        }
      default:
        {
          let t2;
          if ($[48] !== storeView) {
            t2 = <StoreContent storeView={storeView} />;
            $[48] = storeView;
            $[49] = t2;
          } else {
            t2 = $[49];
          }
          content = t2;
        }
    }
  } else {
    let t0;
    if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <ContentSkeleton />;
      $[50] = t0;
    } else {
      t0 = $[50];
    }
    content = t0;
  }
  let t0;
  if ($[51] !== content) {
    t0 = <div className="flex w-full flex-col lg:max-w-[calc(100%-360px-20px)]">{content}</div>;
    $[51] = content;
    $[52] = t0;
  } else {
    t0 = $[52];
  }
  return t0;
};
export default ContentWrapper;